module.exports = __webpack_public_path__ + "img/face-grin-tears.3b2e9b62.svg";